export default {
    MASCULINO: 1,
    FEMININO: 2,
    MASCULINO_TRANSGENERO: 3,
    FEMININO_TRANSGENERO: 4
}